import { useModal } from "@/components/_primitives/Modal/ModalRoot/ModalRoot";
import { Button } from "@/components/Global/Button/Button";
import { FormModalType, useAppContext } from "@/context/AppContext";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";

type RecipeModalButtonProps = {
  modalType: FormModalType;
  icon: string;
  label: string;
};

function RecipeModalButton({ modalType, icon, label }: RecipeModalButtonProps) {
  const { setFormModalType } = useAppContext();
  const { getLabel } = useGlobalContext();
  const { setOpen } = useModal();

  const handleClick = () => {
    setOpen(true);
    setFormModalType(modalType);
  };

  return (
    <Button
      className={`ghost`}
      type="primary"
      href="#"
      target={"_self"}
      onClick={handleClick}
      icon={icon}
    >
      {getLabel(label)}
    </Button>
  );
}

export default RecipeModalButton;
